import { Card, Typography } from 'antd'; // 引入Typography优化样式（可选）
import { getArticleById } from '../../api/mockData.jsx';
import { useNavigate } from "react-router-dom";
// 文章卡片组件
//@param {number} id - 文章编号
//@param {number} [height=100] - 卡片高度，默认100px

const PostCard = ({ id, height = 100 }) => {
  // 1. 获取文章数据,空值兜底
  const item = getArticleById(id) ?? {
    title: '暂无标题',
    summary: '暂无简介', 
    author: '未知作者',
    createTime: '未知时间'
  };

  //获取字段说明
  const title = item?.title ?? '暂无标题';
  const summary = item?.summary ?? '暂无简介'; 
  const author = item?.author ?? '未知作者';
  const createTime = item?.createTime ?? '未知时间';

  const navigate = useNavigate();
  function handleClick() {
    navigate(`/PostDetail/${id}`);
  }
  return (
    <Card onClick={handleClick}
      style={{ height, padding: 12 }} // 增加内边距，优化样式
      hoverable={true} // 鼠标悬浮高亮，提升交互
    >
      {/* 使用Typography优化标题样式，替代原生h1避免样式溢出 */}
      <Typography.Title level={5} style={{ margin: 0, wordBreak: 'break-all' }}>
        {title}
      </Typography.Title>
      {/* 简介添加省略号，避免内容溢出卡片 */}
      <Typography.Paragraph 
        style={{ margin: '8px 0', color: '#666' }}
        ellipsis={{ rows: 2 }} // 最多显示2行，超出省略
      >
        {summary}
      </Typography.Paragraph>
      {/* 作者/时间用小号文字，排版更整洁 */}
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        作者：{author} | 发布时间：{createTime}
      </Typography.Text>
    </Card>
  );
};

export default PostCard;